<template>
   
    <div> 
        <div class="crumbs" hidden="true"  style="margin-left:10px;">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-calendar"></i> 产品管理
                </el-breadcrumb-item>
                <el-breadcrumb-item>产品分类</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        
          <div class="container" > 
            <div class="handle-box" style="overflow-y:hidden;">  
                <span class="label-span">
                    <label class="label">文件名称</label> 
                    <el-input v-model.trim="query.fileName" placeholder="文件名称" class="handle-input mr15"></el-input> 
                </span> 
                <el-button type="success" icon="el-icon-search"  class="mr10"  @click="handleSearch">搜索</el-button> 
                <el-button  type="primary"  icon="el-icon-lx-roundadd" class="mr10"  @click="addBind" >上传文件</el-button>
            </div>
            <ul class="fileImg-ul" v-for="item in tableData">
                <li class='fileImg-li1'>
                    <img v-if="item.fileType=='.jfif' || item.fileType=='.png' || item.fileType=='.jfif' || item.fileType=='.jpg' || item.fileType=='.jpeg' || item.fileType=='.gif'" :src="item.filePath" />

                    <img style='width:80%;margin:10%' v-else :src="formatFileIcon(item.fileName)" />
                </li>
                <li class='fileImg-li2'> 
                    <p class='fileImg-p1'>
                        <el-tooltip class="item" effect="light" content="下载" placement="bottom-start">
                            <i class='el-icon-download' @click="downImg(item)"></i>
                        </el-tooltip>
                        <el-tooltip class="item" effect="light" content="查看" placement="bottom-start">
                            <i class='el-icon-lx-attention' @click="see(item)"></i>
                        </el-tooltip>
                    </p>
                    <p class='fileImg-p1'>
                        <el-tooltip class="item" effect="light" content="删除" placement="bottom-start">
                            <i class='el-icon-delete' @click="handDelete(item)"></i>
                        </el-tooltip>
                        <el-tooltip class="item" effect="light" content="选择" placement="bottom-end">
                            <i class='el-icon-check' @click="handChoose(item)" ></i>
                        </el-tooltip>
                    </p>
                    <p class='fileImg-p2'>{{item.fileSize}}</p>
                </li> 
                <li class='fileImg-li3'>
                    <el-tooltip class="item" effect="dark" :content="item.fileName" placement="bottom-start">
                        <a>{{item.fileName}}</a>
                    </el-tooltip>
                </li> 
            </ul>  
             <div style="clear:both"></div>
            <div class="pagination">
                <el-pagination 
                   background
                    layout="total,  sizes,prev, pager, next,jumper"
                    :page-sizes="[ 20, 50]"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @size-change="handleSizeChange"
                    @current-change="handlePageChange" 
                ></el-pagination>
            </div> 
        </div> 
        <!-- 新建自主渠道弹出框 --> 
        <el-dialog :close-on-click-modal="false" title="上传文件" :visible.sync="addVisible"  :modal='false'top="0px" width="560px">
            <el-form ref="form1" :model="form1" label-width="120px"  @submit.native.prevent="saveForm">
                <el-form-item label="文件上传">
                    <el-upload :fileList="fileList" action="#" drag :file-list="fileList" :on-remove="handleRemove" :auto-upload="false" :limit="10" :on-change="handleChange" :on-exceed="handleExceed"
                               multiple>
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">将文件拖到此处，或点击上传</div>
                        <div class="el-upload__tip" slot="tip">单文件大小不超过50M</div>
                    </el-upload>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer" align="center" >
                <el-button @click="addVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveForm">{{ isSubmitting ? '提交中...' : '提 交' }}</el-button>
            </span>
        </el-dialog>
        <el-dialog :modal-append-to-body='false' :title="dialogImageName"  :visible.sync="dialogVisible" width="550px" top="50px">
            <img width="100%" :src="dialogImageUrl" alt="" style="width:500px">
        </el-dialog>
  

        <!-- 编辑自主渠道弹出框 --> 
        <el-dialog :close-on-click-modal="false" title="编辑计划" :visible.sync="editVisible" :modal-append-to-body='false' top="50px" width="580px">
            <el-form ref="form3" :model="form3" label-width="120px">
                <el-form-item label="预警计划名称">
                    <el-input v-model.trim="form2.name"  placeholder="不超过10个字" ></el-input>
                </el-form-item> 
                <el-form-item label="预警计划描述">
                    <el-input v-model.trim="form2.descript"  placeholder="不超过50个字" ></el-input>
                </el-form-item>    
                <el-form-item label="接口预警转化" style="margin-bottom:20px">
                    <el-button type="primary" @click="add2">添加转化区间</el-button>
                </el-form-item> 
                <div v-for="(item,index) in form2.config" :key="index"> 
                    <el-form-item label="" style="margin-top:-12px">
                        <el-input v-model.trim="form2.config[index].range1" oninput ="value=value.replace(/[^\d]/g,'')" placeholder="最小请求值" style="width:100px;display:inline-block;"></el-input> -
                        <el-input v-model.trim="form2.config[index].range2" oninput ="value=value.replace(/[^\d]/g,'')" placeholder="最大请求值" style="width:100px;display:inline-block;"></el-input> 
                        <el-input v-model.trim="form2.config[index].rangeLimit" oninput="value=value.replace(/[^0-9.]/g,'')" placeholder="转化比例"  style="width:85px;display:inline-block;margin-left:20px;"></el-input> %  
                        <el-button type="danger" size="small" style="margin-left:15px;" icon="el-icon-delete" @click="del2(index)"></el-button> 
                    </el-form-item> 
                </div>   
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit">确 定</el-button>
            </span>
        </el-dialog>
          
    </div>
</template>

<script>
import bus from '../../../components/common/bus';
import { formatFileIcon } from '@/utils/filters';
import {fetchData,saveForm,handDelete,changeForm,changeStatus,fetchDataDir} from './comFile';
export default {

    data() {
        return {  
            isSubmitting: false, // 是否正在提交
            Timeout:'', 
            activeNames:1,
            select:{ option:'',  },
            fileList:[],
            disabled: false,
            dialogVisible:false,
            dialogImageName:'',
            
            array:[1],
            query: { 
                pageIndex: 1,
                pageSize: 20,  
            },
            tableData: [],
            tableData2: [],
            multipleSelection: [],
            delList: [],
            editVisible: false,
            editPlusVisible: false,
            addVisible: false,
            addPlusVisible:false,
            detailVisible:false, 
            dirVisible:false,
            row:{},
            pageTotal: 0,
            form: {  
                ids:'',
                names:'',
            },
            form1: {
                range1:[],
                range2:[], 
                rangeLimit:[]
            },
            form2: {   },
            form3: {   },
            form4: {   },
            idx: -1,
            id: -1
        };
    },
    created() {
         
    },
    //页面加载方法
    mounted: function () { 
        //查询列表
        this.getData();  
    },

    methods: {  
        // 触发搜索按钮
        formatFileIcon,
        handleSearch() {
            this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },

        //重置按钮
        refreshSearch(){ 
            this.$set(this.query, 'fileName', '');   
            this.handleSearch();
        }, 
        //详情图放大
        see(data) {
            if(data.fileName.indexOf('.png')>0 || data.fileName.indexOf('.jpg')>0 || data.fileName.indexOf('.jpeg')>0 || data.fileName.indexOf('.gif')>0 || data.fileName.indexOf('.jfif')>0){
                this.dialogImageUrl = data.filePath;
                this.dialogImageName = data.fileName
                this.dialogVisible = true;
            }else{
                this.$message.error('该文件不是图片格式，无法预览');
            }

        },
        downImg(data){
            if(data.fileName.indexOf('.png')>0 || data.fileName.indexOf('.jpg')>0 || data.fileName.indexOf('.jpeg')>0 || data.fileName.indexOf('.gif')>0 || data.fileName.indexOf('.jfif')>0) {
                const img = new Image();
                img.crossOrigin = "anonymous"; // 解决跨域Canvas污染
                img.onload = () => {
                    const canvas = document.createElement('canvas');
                    canvas.width = img.width;
                    canvas.height = img.height;
                    const ctx = canvas.getContext('2d');
                    ctx.drawImage(img, 0, 0);
                    // 添加文字水印
                    ctx.font = '30px Arial';
                    ctx.fillStyle = 'rgba(255,255,255,0.7)';
                    ctx.fillText('', 50, 50);
                    // 导出下载
                    const dataURL = canvas.toDataURL('image/png');
                    const link = document.createElement('a');
                    link.href = dataURL;
                    link.download = data.fileName;
                    link.click();
                };
                img.src = data.filePath;
            }else{
                window.open(data.filePath);
            }
        },
        handleBig(url) {
            this.dialogImageUrl = url;
            this.dialogVisible = true;
        },
        //文件上传超过最大数量提示
        overMaxImg(file, fileList) {
            this.$message.error('一个批次文件最多只能上传7张');
        },
        //详情图上传成功追加数据 
        handleChange(file, fileList) {
            const isLt1M = file.size < 1024 * 1024 * 20;
            if (!isLt1M) {
                this.$message.error('单张文件不超过 20MB!');
                fileList.splice(-1, 1);
                return false;
            }
            this.fileList = fileList;

        },
     
        handleRemove(file) {
            let i = this.fileList.indexOf(file);
            this.fileList.splice(i, 1);
        },

        //触发刷新按钮
        refresh(){
            history.go(0); 
        }, 

        //查询
        getData(){ 
            this.query.conType = '2';    
            fetchData(this.query).then(res => {  
                if(res.code=='200'){ 
                    this.tableData = res.data.list;
                    this.pageTotal = res.data.pageTotal ;  
                }else{
                    this.tableData = []; 
                    this.pageTotal = 0;
                } 
                
            });
        },
        //渠道字典表
        channelDir(){
            this.dirVisible=true;
            fetchDataDir(this.query).then(res => {  
                if(res.code=='200'){ 
                    this.tableData2 = res.data;   
                }else{
                    this.$message("暂无数据");
                } 
                
            });

        },
       

        // 新增渠道
        addBind() {
            this.addVisible = true; 
        },
        //保存新增
        saveForm() {   
            if(this.fileList.length==0){
                this.$message.error("请上传文件文件");
                return;
            } 
            let formData = new FormData();   
            for(var i=0;i<this.fileList.length;i++){
                formData.append("files",this.fileList[i].raw,this.fileList[i].name);   
            }
            
            this.loading = true; 
            this.addVisible = false; 
            saveForm(formData).then(res => {
                this.loading = false;  
                if(res.code=='200'){  
                    this.$message.success(res.message); 
                    this.refreshSearch();
                    this.closeAllDialogs();
                }else{
                    this.addVisible = true;
                    this.$message.error(res.message); 
                } 
                this.isSubmitting = false;
            });
        },
        closeAllDialogs() {
            this.addVisible = false;   // 外层弹窗
            this.showVisible = false;  // 内层文件弹窗
            // 关闭其他可能打开的弹窗...
        },
        

        // 编辑操作
        handleEdit(index, row) {      
            this.editVisible = true;
            this.form2 = row; 
        },
 
        
        // 保存更改
        saveEdit() { 
            if( !this.form2.name ){ 
                this.$message.error("请填写预警计划名称");
                return;
            }  
            if(this.form2.config.length==0){ 
                this.$message.error("请添加转化区间");
                return;
            }
            for(var i=0;i<this.form2.config.length;i++){
                if( !this.form2.config[i].range1 || this.form2.config[i].range1=='' ){ 
                    this.$message.error("请填写第 "+(i+1)+" 行中-请求最小值");
                    return;
                }  
                if( !this.form2.config[i].range2 || this.form2.config[i].range2=='' ){ 
                    this.$message.error("请填写第 "+(i+1)+" 行中-请求最大值");
                    return;
                }  
               if( !this.form2.config[i].rangeLimit || this.form2.config[i].rangeLimit=='' ){ 
                    this.$message.error("请填写第 "+(i+1)+" 行中-转化比例");
                    return;
                }  
            }  
            this.form2.configs = JSON.stringify(this.form2.config);
            changeForm(this.form2).then(res => {
                if(res.code=='200'){
                    this.editVisible = false; 
                    this.$message.success(res.message); 
                    this.getData();
                }else{
                    this.$message.error(res.message); 
                }
            });
        },
        // q启用、禁用--改变状态
        handleStatus(index, row) {  
             var tips ;
            var content;
            if(row.status=='0'){ 
                row.status='1';
                tips = "禁用";
                content = "确定禁用吗？";
            }else{ 
                row.status = '0';
                tips = "启用";
                content = "确定启用吗？"; 
            }
            // 二次确认删除
            this.$confirm(content, '提示', {
                type: 'warning'
            }).then(() => { 
                if(row.status=='0'){ 
                    row.status='1' 
                }else{ 
                    row.status='0' 
                }
                changeStatus(row).then(res => {
                    if(res.code=='200'){ 
                        this.$message.success(tips+'成功'); 
                        this.getData();
                    }else{ 
                        if(row.status=='0'){ 
                            row.status='1' 
                        }else{ 
                            row.status='0' 
                        }
                        this.$message.error(tips+'失败');
                    } 
                });
            })
            .catch(() => {}); 
           
        },
 
        
        //详情
        handleDetail(index, row){
            this.form2 = row; 
            if(row.channelType=='1'){
                this.detailVisible = true; 
            }
            
        },
        // 删除
        handDelete( row) {   
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            }).then(() => {
                handDelete(row).then(res => {
                    if(res.code=='200'){ 
                        this.$message.success('删除成功');  
                        this.getData();
                    }else{
                        this.$message.error(res.meessage); 
                    } 
                });
            }) 
        },
        handChoose(row){
            setTimeout( () => {
                bus.$emit('file-choose',row);
                his.showVisible = false;
            }, 100) 
        },
        // 分页导航
        handlePageChange(val) { 
            this.$set(this.query, 'pageIndex', val);
            this.getData();
        },
        //分页数量更改导航
        handleSizeChange(val){
            this.$set(this.query, 'pageSize', val);
            this.getData();
        }
    }
};
</script>

<style scoped>
.label{
    background: #eee;
    font-size: 14px;
    height: 32px;
    display: inline-block;
    line-height: 33px;
    width:100px;
    text-align:center;
    color: #555;
  }
  .label-span{
      display: inline-block;
      height: 45px;
  }
.handle-box {
    width:100%;
    margin-bottom: 20px;
    overflow-x:auto;
}

.handle-select {
    width: 100px;
    display: inline-block;
}

.handle-input {
    width: 150px;
    display: inline-block;
}
.handle-del {
    float:right; 
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
    margin-left:0;
}
.mr15 {
    margin-right: 15px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

</style>
<style>
.el-upload-list--picture-card .el-upload-list__item {
    width: 120px;
    height: 120px;
}

.el-upload--picture-card {
    width: 120px;
    height: 120px;
    line-height: 120px;
}

</style>
